var _excluded = ["as", "size", "width", "height", "fill", "stroke", "theme"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { oneOf, elementType, string, checkPropTypes, oneOfType, number } from 'prop-types';
import { withTheme } from 'styled-components';
import get from 'lodash.get';
import Box from '../Box';

var Icon = function Icon(_ref) {
  var Component = _ref.as,
      size = _ref.size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      fill = _ref.fill,
      stroke = _ref.stroke,
      theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    as: Component,
    width: get(theme.yoga.spacing, width, width),
    height: get(theme.yoga.spacing, height, height)
  }, fill && {
    fill: get(theme.yoga.colors, fill, fill)
  }, stroke && {
    stroke: get(theme.yoga.colors, stroke, stroke)
  }, props));
};

var commonSizes = ['xxxsmall', 'xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge', 'huge', 'xhuge'];
Icon.propTypes = {
  /** SVG to be rendered. */
  as: elementType.isRequired,

  /** Fill color. Use it as one of theme.colors
   * tokens (vibin, neutral, stamina...) */
  fill: string,

  /** Stroke color. Use it as one of theme.colors
   * tokens (vibin, neutral, stamina...) */
  stroke: string,

  /** Horizontal size of the SVG. Use it as one of
   * theme.spacing tokens (xxsmall, small, medium...) */
  width: oneOfType([oneOf(commonSizes), string, number]),

  /** Vertical size of the SVG. Use it as one of
   * theme.spacing tokens (xxsmall, small, medium...) */
  height: oneOfType([oneOf(commonSizes), string, number]),

  /** Size for vertical and horizontal of the SVG.
   * Use it as one of theme.spacing tokens (xxsmall, small, medium...) */
  size: function size(props, propName, componentName) {
    var _checkPropTypes;

    var size = props.size,
        width = props.width,
        height = props.height;

    if (size && (width || height)) {
      return new Error("you must use only " + propName + ", alone, or width and/or height in " + componentName);
    }

    checkPropTypes((_checkPropTypes = {}, _checkPropTypes[propName] = oneOfType([oneOf(commonSizes), string, number]), _checkPropTypes), {
      size: size
    }, 'prop', componentName);
    return null;
  }
};
Icon.defaultProps = {
  fill: undefined,
  stroke: undefined,
  width: undefined,
  height: undefined,
  size: undefined
};
export default withTheme(Icon);